/**
 * @typedef {Object} FrontendTestVariation
 * @property {string} test
 * @property {boolean} [isOriginal]
 * @property {boolean} [impressionOnPageLoad]
 * @property {boolean} [exposureOnDisplay=false] Defer PostHog exposure and attribution until the UI is shown.
 */

module.exports = {
	'WASABI_BASE_URL'           : 'https://wasabi.travelgroep.nl',
	'WASABI_DEFAULT_APPLICATION': 'Frontends',
	'WASABI_TIMEOUT_IN_MS'      : 5000,
	'WASABI_EVENT_NAMES'        : {
		'IMPRESSION': 'IMPRESSION'
	},
	'TEST_QUERY_KEY'              : 'exp',
	'ACTIVE_VARIATIONS_COOKIE_KEY': 'WASABI_activeVariations',
	'TEST_VARIATIONS_SEPARATOR'   : '|'
};